var React = require('react');

function CircuitHorizontal (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-110 -826)"},[React.createElement("line",{"y1":"510","transform":"translate(620 849) rotate(90)","fill":"none","stroke":"#eace00","strokeWidth":"4","key":0}),React.createElement("line",{"y1":"510","transform":"translate(620 829) rotate(90)","fill":"none","stroke":"#eace00","strokeWidth":"4","key":1})]));
}

CircuitHorizontal.defaultProps = {"width":"510","height":"26","viewBox":"0 0 510 26","preserveAspectRatio":"none"};

module.exports = CircuitHorizontal;

CircuitHorizontal.default = CircuitHorizontal;
